import { createAction, createSlice } from '@reduxjs/toolkit';
import { deprecationWarning } from '@wsc/utils/consoleHelpers';

/** Deprecated Events, do not add to these */
const SET_MODAL_PROPS = 'SET_MODAL_PROPS';
const SET_MODAL_VISIBILITY = 'SET_MODAL';

const initialState = {};

/**
 * @module ModalDataReducer
 *
 * Reducer for modalData slice.
 *
 */

const slice = createSlice({
	name: 'modalData',
	initialState: initialState,
	reducers: {
		setModalProps: (state, action) => {
			const { key, props } = action.payload;
			state[key] = props;
		},
		setModalVisibility: (state, action) => {
			const { key, modalState } = action.payload;
			if (modalState === false) {
				state[key] = { visible: false };
			} else {
				state[key] = {
					visible: modalState,
				};
			}
		},
	},
	extraReducers: (builder) => {
		/** DEPRECATED Actions, left here for backwards compatibility. Do not add anything to these, use above reducers instead.*/
		builder.addCase(createAction(SET_MODAL_PROPS), (state, action) => {
			deprecationWarning(
				`'${SET_MODAL_PROPS}' event will be deprecated. Please use 'modalData/setModalProps' instead. \nAction structure changes from \n{type: 'SET_MODAL_PROPS', key: string, props: object}\n to\n {type: 'modalData/setModalProps', payload: {key: string, props: object}}`,
			);
			const { key, props } = action;
			state[key] = props;
		});

		builder.addCase(createAction(SET_MODAL_VISIBILITY), (state, action) => {
			deprecationWarning(
				`'${SET_MODAL_VISIBILITY}' event will be deprecated. Please use 'modalData/setModalVisibility' instead.\nAction structure changes from \n{type: 'SET_MODAL', key: string, state: bool}\n to\n {type: 'modalData/setModalVisibility', payload: {key: string, modalState: bool}}`,
			);
			const { key, state: modalState } = action;
			if (modalState === false) {
				state[key] = { visible: false };
			} else {
				state[key] = {
					visible: modalState,
				};
			}
		});
	},
});

export const { setModalProps, setModalVisibility } = slice.actions;

export default slice.reducer;
